/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, December 28th 2023, 6:44:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { SwitchFormInput } from "ui-widgets/forms";
import { InputHelpDialogWrapper, EmphasisText } from "ui-widgets";

export const ResubmissionTaskSettings = () => (
  <>
    <h3>
      <EmphasisText>Resubmission Settings</EmphasisText>
    </h3>
    <InputHelpDialogWrapper
      helpTitle="Allow Edit All Fields"
      helpContent="Select this if you want the submitter of the application to be able to edit all fields during a resubmission."
    >
      <SwitchFormInput<TaskTemplate>
        schema_field_key="resubmit_allow_edit_all_fields"
        label="Allow editing of all fields for this resubmit task?"
      />
    </InputHelpDialogWrapper>
  </>
);
